/**
 * CUSTOM (HOMYCASA): Financing apps (Klarna, Scalapay, seQura) append their
 * "learn more" modals to <body>, outside the browser top layer. The financing
 * drawer (blocks/popup-link.liquid) opens with dialog.showModal(), which lives
 * in the top layer and therefore always covers those modals, regardless of
 * z-index.
 *
 * Workaround: close any open dialog as soon as the shopper interacts with a
 * financing widget (click, capture phase in case the widget stops propagation)
 * or a financing modal is injected into <body> (MutationObserver fallback for
 * widgets rendered inside iframes, whose clicks never reach this document).
 */

const FINANCING_WIDGET_SELECTOR = [
  'klarna-placement', 
  '[id*="klarna" i]',
  '[class*="klarna" i]',
  'scalapay-widget',
  '[id*="scalapay" i]',
  '[class*="scalapay" i]',
  '[id*="sequra" i]',
  '[class*="sequra" i]',
].join(',');

const FINANCING_APP_PATTERN = /klarna|scalapay|sequra/i;

/** Closes every dialog-component whose <dialog> is currently open. */
function closeOpenDialogs() {
  for (const component of document.querySelectorAll('dialog-component')) {
    // @ts-ignore
    const dialog = component.refs?.dialog;
    if (!dialog?.open) continue;

    // @ts-ignore
    if (typeof component.closeDialog === 'function') {
      // @ts-ignore
      component.closeDialog();
    } else {
      dialog.close();
    }
  }
  console.log("[HOMYCASA] financing-dialog-close.js loaded");
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const widget = target?.closest(FINANCING_WIDGET_SELECTOR);
    if (!widget?.closest('dialog-component dialog[open]')) return;

    closeOpenDialogs();
  },
  { capture: true }
);

const observer = new MutationObserver((mutations) => {
  if (!document.querySelector('dialog-component dialog[open]')) return;

  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      // Widgets hydrating inside the drawer itself must not close it.
      if (node.closest('dialog-component')) continue;

      const marker = `${node.id} ${node.getAttribute('class') ?? ''}`;
      if (FINANCING_APP_PATTERN.test(marker)) {
        closeOpenDialogs();
        return;
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });


